import apiRequest from '@libs/apiRequest';
import { getFormValues } from 'redux-form';
import { call, put, select } from 'redux-saga/effects';
import { FORM_NAME } from '../../common';
import { setLoading, setSnack } from 'utilities/redux.actions';
import { CALENDER } from 'common/redux.datasets';

export default function* (action) {
    const {
        meta: { handleSubmit = () => { } },
        ...rest
    } = action;

    yield put(setLoading(true));

    const {id,holidays, ...allSelector} = yield select(
        getFormValues(FORM_NAME)
    );

    const payloadData = JSON.stringify(allSelector);
    
    try {
        const { data } = yield call(
            apiRequest,
            {
                url: `calender/update?id=${id}`,
                method: 'post',
                data: payloadData,
            }
        );
        yield put(setLoading(false));
        yield put(setSnack({
            message: "Calender updated successfully",
            type: 'success',
        }));
        yield put({
            type: "handleUpdate",
            payload: {
                entity: CALENDER,
                value: data,
                key:"name"
            },
        });
        return handleSubmit(data);
    } catch (error) {
        yield put(setLoading(false));
        yield put(setSnack({
            message: error?.response?.data?.message || error?.message,
            type: 'error',
        }));
        return handleSubmit(error);
    }
}
